export const systemsNaming = {
    "Google Ads": "google",
    "Yandex Direct": "yandex",
    "TikTok": "tiktok",
    "Facebook": "facebook",
}